import { createEffect } from '@databases/selections';
import { type SelectionsApiContract } from '@databases/selections-api-types';

import {
  aifcDebugSelectionsState,
  type AifcDebugSelectionsState
} from './aifc-debug-selections-state';

export interface AifcDebugSelectionsEffectDeps {
  selectionsApi: SelectionsApiContract;
}

export const createAifcDebugSelectionsEffect = createEffect(
  ({ selectionsApi }: AifcDebugSelectionsEffectDeps) => {
    return {
      deltaTypes: ['selectionReplaced', 'selectionModified'] as const,

      onDelta() {
        const resolved = selectionsApi.getResolvedSelection();

        const next: AifcDebugSelectionsState = {
          selectedEntireFields:
            resolved.mode === 'column' ? resolved.fields.map((f) => f.fieldId) : [],
          selectedEntireEntries:
            resolved.mode === 'row' ? resolved.entries.map((e) => e.entryId) : [],
          selectedValues:
            resolved.mode === 'cell'
              ? resolved.values.map((v) => ({ entryId: v.entryId, fieldId: v.fieldId }))
              : []
        };

        aifcDebugSelectionsState.setAifcDebugSelectionsState(next);
      },

      dispose() {
        aifcDebugSelectionsState.resetAifcDebugSelectionsState();
      }
    };
  }
);
